import env from './env';

/**
 * The ``app`` function returns the fully qualified path to the app directory.
 * You may also use the ``app`` function to generate a fully qualified path
 * to a given file relative to the application directory.
 *
 * @param {string} path Added directory path
 * @return {string}
 */

const app = path => env('PUBLIC_URL') + path;

/**
 * Create a URL for an entity using the current schema of the request.
 * Indicates the static folder.
 *
 * @param {string} path Added directory path
 * @return {string}
 */

const asset = param => app('/static') + param;

/**
 * The location address will break the search words
 * and return an object in the form of a **key**-**value**.
 *
 * If a given key is given,
 * the value for that key is returned,
 * if no data returns **undefined**.
 *
 * @param {string} param
 * @return {string}
 */

const parse = (param) => {
  const search = window.location.search.substring(1);
  const params = search.split('&');
  const data = {};

  params.forEach((item) => {
    const [key, value] = item.split('=');
    data[key] = value;
  });

  if (param) return data[param];
  return data;
};

/**
 * The ``server`` function returns the full path of the server directory.
 *
 * It uses the configuration in the **config** file according to the generated schema.
 *
 * @param {string} key Object key used in the **config** file
 * @param {string} path Added directory path
 * @return {string}
 */

const server = (key, path) => window.config.server[key] + path;

/**
 * The ``cdn`` function returns the full path of the file server directory.
 *
 * It uses the configuration in the **config** file according to the generated schema.
 *
 * @param {string} path Added directory path
 * @return {string}
 */

const cdn = path => server('cdn', path);

/**
 * The ``endpoint`` function returns the full path of the application's base APIs server directory.
 *
 * It uses the configuration in the **config** file according to the generated schema.
 *
 * @param {string} path Added directory path
 * @return {string}
 */

const endpoint = path => server('origin', path);

export default {
  app,
  asset,
  cdn,
  endpoint,
  parse,
  server,
};
